const context = require.context('.', false, /^((?!index).)*\.js$/);
module.exports = { __esModule: true };

context.keys().forEach((key) => {
  const moduleName = /^[^\w]+(.*)\.js$/.exec(key)[1];
  module.exports[moduleName] = context(key).default;
});
